import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { FIREWALL_RULE_TABS, type FirewallRuleTab } from '@/features/admin/shared/tabs';
import { FirewallRuleDetailPage } from '@/features/admin/firewall/firewall-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Détail d'une règle de pare-feu (porting README #22). L'onglet actif vit dans l'URL (`?tab=`). */
export const Route = createFileRoute('/$tenant/firewall/$ruleId')({
  validateSearch: (search: Record<string, unknown>): { tab: FirewallRuleTab } => ({
    tab: FIREWALL_RULE_TABS.parse(search['tab']),
  }),
  component: FirewallRuleRoute,
});

function FirewallRuleRoute() {
  const { tenant, ruleId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="firewall"
      crumbs={[{ label: t('nav.items.firewall') }, { label: ruleId, mono: true }]}
    >
      <FirewallRuleDetailPage
        tenantId={tenant}
        ruleId={ruleId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
